const FolderFancySvg = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7928 3.36011H17.5856L18.7928 6.37823H20V4.56737C20 3.90339 19.4568 3.36011 18.7928 3.36011Z"
        fill="#FF933A"
      />
      <path
        d="M17.5854 3.36011H7.58545V6.37823H18.7927V4.56737C18.7927 3.90339 18.2494 3.36011 17.5854 3.36011Z"
        fill="#FFA55C"
      />
      <path
        d="M18.7927 15.4326L17.5854 18.4507H18.7927C19.4567 18.4507 19.9999 17.9075 19.9999 17.2435V16.6399L18.7927 15.4326Z"
        fill="#FFD074"
      />
      <path
        d="M17.5854 3.36011H7.58545V6.37823H18.7927V4.56737C18.7927 3.90339 18.2494 3.36011 17.5854 3.36011Z"
        fill="#FFA55C"
      />
      <path
        d="M18.7927 15.4326L17.5854 18.4507H18.7927C19.4567 18.4507 19.9999 17.9075 19.9999 17.2435V16.6399L18.7927 15.4326Z"
        fill="#FF933A"
      />
      <path
        d="M18.7928 17.2435V15.4326L0 16.6398V17.2435C0 17.9075 0.543242 18.4507 1.20723 18.4507H17.5855C18.2495 18.4507 18.7928 17.9075 18.7928 17.2435Z"
        fill="#F6B205"
      />
      <path
        d="M18.7928 5.1709H17.5856L18.7928 16.6397H20V6.37816C20 5.71418 19.4568 5.1709 18.7928 5.1709Z"
        fill="#F6B205"
      />
      <path
        d="M18.7928 6.37826C18.7928 5.71428 18.2495 5.17104 17.5855 5.17104H11.2072L9.46238 2.55377C9.0941 2.00135 8.24945 1.54932 7.58547 1.54932H1.20723C0.543242 1.54928 0 2.09252 0 2.7565V16.6398H18.7928V6.37826Z"
        fill="#FFC107"
      />
    </svg>
  );
};
export default FolderFancySvg;
